/** Стрелки в группе радиокнопок.
 *
 * `role="radiogroup"` обещает модель взаимодействия: стрелками между вариантами,
 * Tab — мимо всей группы. В приложении девять таких групп, и ни в одной не было
 * обработчика клавиш — роль объявлялась, поведение нет. Для человека на
 * клавиатуре это хуже, чем отсутствие роли: он ждёт стрелок и не получает их.
 *
 * Функция вешается на контейнер группы и работает с любой её вёрсткой: ищет
 * своих детей по `role="radio"`, а не по классам.
 */
export function onRadioKeys(e: React.KeyboardEvent<HTMLElement>): void {
  const КЛАВИШИ = ["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp", "Home", "End"];
  if (!КЛАВИШИ.includes(e.key)) return;
  const stops = [...e.currentTarget.querySelectorAll<HTMLElement>('[role="radio"]')]
    .filter((el) => !el.hasAttribute("disabled"));
  if (stops.length < 2) return;
  const here = stops.indexOf(document.activeElement as HTMLElement);
  if (here === -1) return;
  e.preventDefault();
  const шаг = e.key === "ArrowRight" || e.key === "ArrowDown" ? 1 : -1;
  const next =
    e.key === "Home" ? 0
    : e.key === "End" ? stops.length - 1
    // По кругу: в конце списка стрелка вправо возвращает к началу — так ведут
    // себя нативные радио, и упереться в невидимую стену человек не должен.
    : (here + шаг + stops.length) % stops.length;
  stops[next]?.focus();
  stops[next]?.click();
}
